export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;

export const roles = {
  GAMEDAY_EXTERNAL_ADMIN: 'GAMEDAY_EXTERNAL_ADMIN',
  GAMEDAY_INTERNAL_ADMIN: 'GAMEDAY_INTERNAL_ADMIN',
  GAMEDAY_INVOICE_ONLY: 'GAMEDAY_INVOICE_ONLY',
  GAMEDAY_VIEW_ONLY: 'GAMEDAY_VIEW_ONLY',
  GAMEDAY_PRODUCTION_SUPPORT: 'GAMEDAY_PRODUCTION_SUPPORT',
  GAMEDAY_STANDARD_USER: 'GAMEDAY_STANDARD_USER',
  GAMEDAY_SUPER_USER: 'GAMEDAY_SUPER_USER'
};

export const sortBy = {
  ROLE_DESC: 'roleDesc'
};

export const filterType = {
  ACC_NUM: 'accountNumber',
  ROLE: 'role',
  EMAIL_NOT_LIKE: 'emailNotLike'
};
